;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import clsx from 'clsx'
import type React from 'react'

/**
 * The form-level failure banner every form shares. `role="alert"` makes the message reach
 * screen readers when it appears; visually it is the same red panel the forms used to copy-paste.
 */
export function FormErrorBanner({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div
      role="alert"
      className={clsx(
        className,
        'rounded-2xl border border-red-500/20 bg-red-500/5 px-4 py-3 text-sm/6 text-red-600 dark:text-red-300',
      )}
    >
      {children}
    </div>
  )
}
